import { useMemo } from "react";
import { useReducedMotion } from "framer-motion";
import "./infantil-mariposas.css";
import Portada from "./components/Portada";
import Eventos from "./components/Eventos";
import Itinerario from "./components/Itinerario";
import Rsvp from "./components/Rsvp";
import { EnlacesSeccion, AccesosSeccion, CierreSeccion } from "./components/Extras";
import {
  CuentaRegresiva,
  Calendario,
  Galeria,
  VideoSeccion,
  MusicaSeccion,
  useScrollSuave,
  construirEstiloTema,
} from "../shared";

// Prefijo de clases de esta plantilla: km- (variables CSS: --km-*)
const P = "km";
const conPrefijo = (Comp) => (props) => <Comp {...props} p={P} />;

const COMPONENTES = {
  cuentaRegresiva: conPrefijo(CuentaRegresiva),
  eventos: Eventos,
  calendario: conPrefijo(Calendario),
  galeria: conPrefijo(Galeria),
  itinerario: Itinerario,
  video: conPrefijo(VideoSeccion),
  musica: conPrefijo(MusicaSeccion),
  rsvp: Rsvp,
  enlaces: EnlacesSeccion,
  accesos: AccesosSeccion,
  cierre: CierreSeccion,
};

export default function InfantilMariposas({
  datos,
  desactivarScrollSuave = false,
  onConfirmarAsistencia,
  onAbrirLibroFirmas,
  onAbrirAlbumColaborativo,
}) {
  const reduceMotion = useReducedMotion();
  useScrollSuave(reduceMotion || desactivarScrollSuave);

  const estiloTema = useMemo(() => construirEstiloTema(datos.tema, "km"), [datos.tema]);

  const acciones = useMemo(
    () => ({ onConfirmarAsistencia, onAbrirLibroFirmas, onAbrirAlbumColaborativo }),
    [onConfirmarAsistencia, onAbrirLibroFirmas, onAbrirAlbumColaborativo]
  );

  const secciones = datos.secciones || [];
  const portadaCfg = secciones.find((s) => s.id === "portada");
  const mostrarPortada = portadaCfg ? portadaCfg.visible !== false : true;

  const ordenadas = useMemo(
    () =>
      secciones
        .filter((s) => s.id !== "portada" && s.visible !== false && COMPONENTES[s.id])
        .sort((a, b) => (a.orden ?? 0) - (b.orden ?? 0)),
    [secciones]
  );

  return (
    <div className="km-invitation" style={estiloTema} data-testid="km-invitacion">
      {mostrarPortada && <Portada datos={datos} />}
      <main id="km-contenido">
        {ordenadas.map((seccion) => {
          const Componente = COMPONENTES[seccion.id];
          return <Componente key={seccion.id} datos={datos} seccion={seccion} acciones={acciones} />;
        })}
      </main>
    </div>
  );
}
